import translate from '@i18n'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

interface AnimatedPlusMinusButtonProps {
  isPlus: boolean
  onClick: () => void
}

const StyledButton = styled.button`
  border: 0;
  background: transparent;
  flex-grow: 1;
  text-align: end;
  cursor: pointer;
  line-height: 0;
  padding: 0;
  display: flex;
  justify-content: flex-end;
`

const PlusMinusContainer = styled.div`
  position: relative;
  display: flex;
  width: 12px;
  height: 12px;
`

const VerticalBar = styled.div<{ isPlus: boolean }>`
  ${({
    isPlus,
    theme: {
      colors: {
        grey: { grey_100 },
      },
    },
  }) => css`
    position: absolute;
    top: 0;
    left: 5px;
    width: 2px;
    height: 12px;
    background-color: ${grey_100};
    transition: all 300ms ease-out;
    transform: rotate(${isPlus ? 0 : 90}deg);
  `}
`

const HorizontalBar = styled.div`
  ${({
    theme: {
      colors: {
        grey: { grey_100 },
      },
    },
  }) => css`
    position: absolute;
    top: 5px;
    left: 0;
    width: 12px;
    height: 2px;
    background-color: ${grey_100};
  `}
`

const AnimatedPlusMinusButton: FunctionComponent<
  AnimatedPlusMinusButtonProps
> = ({ onClick, isPlus }) => (
  <StyledButton
    aria-label={isPlus ? translate('more') : translate('less')}
    onClick={onClick}>
    <PlusMinusContainer>
      <VerticalBar isPlus={isPlus} />
      <HorizontalBar />
    </PlusMinusContainer>
  </StyledButton>
)

export default AnimatedPlusMinusButton
